import React, { useState } from "react";
import { Box, Spinner, Text } from "grommet"; // Import Text for disclaimer
import { HeaderNavigation } from "../../components/Headers/GlobalHeader";
import { StickyFooter } from "../../components/Footers/GlobalFooter";
import { QuizFields } from "../../components/QuizComponents/QuizFields";
import { QuizSummary } from "../../components/QuizComponents/QuizSummary";
import { useNavigate } from "react-router-dom";
import API_URL from "../../config/config";
import axios from "../../config/adminAxios";
import { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { useQuizContext } from "../../contexts/QuizContext";

const QuizSettingsPage = () => {
  const [showSummary, setShowSummary] = useState(false);
  const navigate = useNavigate();
  const [quizSettings, setQuizSettings] = useState({
    difficulty: "Easy",
    numberOfQuestions: 10,
    skillDistribution: {},
  });
  const [loading, setLoading] = useState(false);
  const { user } = useContext(AuthContext);
  const { quizStarted, allowQuizAttempt } = useQuizContext();
  const user_id = user?.user_table_id ?? user?.user_id;

  // Function to format the date as YYYY-MM-DD
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);
    return `${year}-${month}-${day}`;
  };

  // Function to format the time as HH:MM:SS
  const formatTime = (date) => {
    const hours = `0${date.getHours()}`.slice(-2);
    const minutes = `0${date.getMinutes()}`.slice(-2);
    const seconds = `0${date.getSeconds()}`.slice(-2);
    return `${hours}:${minutes}:${seconds}`;
  };

  const handleStartAssessment = async () => {
    setLoading(true);
    try {
      const now = new Date();
      const currentDate = formatDate(now); // Get the formatted date
      const currentTime = formatTime(now); // Get the formatted time

      const data = {
        user_id: user_id,
        subProductSkillIds: quizSettings.skillDistribution,
        difficulty:
          quizSettings.difficulty === "Easy"
            ? "0"
            : quizSettings.difficulty === "Intermediate"
              ? "1"
              : "2",
        query_count: quizSettings.numberOfQuestions,
        date: currentDate, // Use formatted date
        time: currentTime, // Use formatted time
      };
      
      const response = await axios.post(
        `${API_URL}/quiz/startAssessment`,
        data,
      );

      if (response) {
        const assessmentId = response.data.assessment_id;
        const query_count = data.query_count;

        if (!quizStarted) {
          allowQuizAttempt();
        }
        setLoading(false);
        navigate(`/${user_id}/assessment/${assessmentId}`, {
          state: {
            query_count,
            subProductSkillIds: quizSettings.skillDistribution,
          },
        });
      } else {
        setLoading(false);
        alert("Failed to start assessment.");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error starting assessment:", error);
      alert("An error occurred while starting the assessment.");
    }
  };

  const handleSubmit = ({ totalQuestions, skillDistribution }) => {
    
    setQuizSettings({
      ...quizSettings,
      numberOfQuestions: totalQuestions, // Update total questions
      skillDistribution: skillDistribution, // Include skill-based question distribution
    });
    setShowSummary(true); // Move to the summary page
  };

  const handleModify = () => {
    setShowSummary(false);
  };
  if (loading) {
    return (
      <Box fill align="center" justify="center">
        <Spinner size="large" />
        <Text>Starting assessment...</Text>
      </Box>
    );
  }
  return (
    <Box fill="vertical" justify="between">
      <Box flex="grow">
        <HeaderNavigation />
        <Box flex="grow">
          {!showSummary ? (
            <QuizFields onSubmit={handleSubmit} data={user_id} />
          ) : (
            <QuizSummary
              difficulty={quizSettings.difficulty}
              numberOfQuestions={quizSettings.numberOfQuestions}
              onModify={handleModify}
              onStart={handleStartAssessment} // Call handleStartAssessment on start
            />
          )}
        </Box>
      </Box>
      <StickyFooter />
    </Box>
  );
};
export default QuizSettingsPage;
